<!--

Do not use this component from Vue.js code.

It's entirely trivial, just inline the bits that you need.

-->
<template>
	<promise-button :class="cssClass" :callback="onClick">
		{{ caption }}
	</promise-button>
</template>
<script lang="ts">
import axios from "axios";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import { okCancel } from "./Notifications/Prompts";
import PromiseButton from "@/common/PromiseButton.vue";

@Component({
	components: {
		PromiseButton,
	},
})
export class Button extends Vue {
	@Prop({ type: String, required: true }) caption!: string;
	@Prop({ type: String, required: true }) protected callback!: string;
	@Prop({ type: String, required: true }) cssClass!: string;
	@Prop({ type: String, required: false }) protected confirmationText!: string;

	async onClick() {
		if (this.confirmationText && !await okCancel(this.confirmationText)) {
			return;
		}

		const url = (await axios.get(this.callback)).data.redirectUrl;
		if (url) {
			window.location.href = url;
		}
	}
}

export default toNative(Button);
</script>
